<template>
	<div class="flexbox">
		<div v-for="(client, index) in clients" :key="index">
			<span class="helper"></span>
			<a :href="client.href" target="_blank">
				<img :src="require('@/assets/img/categories/' + client.img)" :style="{ maxHeight: client.height, maxWidth: client.width}"/>
			</a>
		</div>
	</div>
</template>

<script>
export default {
	name: "Clients",
	props: {
		clients: {
			type: Array,
			required: true,
		},
	}
}
</script>

<style scoped>
.flexbox {
	display: flex;
    justify-content: space-evenly;
    margin-bottom: 0.5em;
    flex-wrap: wrap;
}
.flexbox > div {
	display: inline;
	text-align: center;
}
.flexbox img {
	vertical-align: middle;
	max-width: 200px;
	max-height: 115px;
	min-height: 44px;
}
.helper {
	display: inline-block;
	height: 100%;
	vertical-align: middle;
}
</style>